import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Stickyfill from 'stickyfill';
import {
  related as relatedPropType,
} from 'lib/CustomPropTypes';
import RelatedItem from './Item';

class Related extends React.Component {
  recRef = React.createRef();

  static propTypes = {
    title: PropTypes.string.isRequired,
    linkTracking: PropTypes.string.isRequired,
    elementId: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(relatedPropType).isRequired,
    isTrending: PropTypes.bool,
    isNBCNewsCommerce: PropTypes.bool,
    isBetterNewsCommerce: PropTypes.bool,
    additionalClasses: PropTypes.string,
    isRightRail: PropTypes.bool,
  };

  static defaultProps = {
    isTrending: false,
    isNBCNewsCommerce: false,
    isBetterNewsCommerce: false,
    additionalClasses: '',
    isRightRail: false,
  };

  componentDidMount() {
    const { isTrending, isNBCNewsCommerce } = this.props;
    if (isTrending || isNBCNewsCommerce) {
      this.stickyfill = Stickyfill();
      this.stickyfill.add(this.recRef.current);
    }
  }

  componentWillUnmount() {
    if (this.stickyfill) {
      this.stickyfill.remove(this.recRef.current);
    }
  }

  render() {
    const {
      title,
      items,
      elementId,
      linkTracking,
      isTrending,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
      additionalClasses,
      isRightRail,
    } = this.props;

    const singleItem = items.length === 1;
    const isNotRightRail = !isRightRail;

    if (isNotRightRail && this.stickyfill) {
      this.stickyfill.remove(this.recRef.current);
    }

    return (
      <section
        className={classNames(
          'related',
          {
            'related--trending': isTrending || isNBCNewsCommerce,
            'related--single': singleItem && isNotRightRail,
          },
          additionalClasses,
          'dn-print',
        )}
        data-test="related"
        ref={this.recRef}
      >
        <h3
          className={classNames({
            related__title: true,
            'related__title--trending': isTrending,
            'related__title--nbcnews-commerce': isNBCNewsCommerce,
            'related__title--betternews-commerce': isBetterNewsCommerce,
          })}
        >
          {title}
        </h3>
        <div
          id={elementId}
          className={classNames(
            'related__items',
            {
              'related__items--vertical': ((isTrending || isNBCNewsCommerce) && isRightRail),
            },
            {
              'related__items--nbcnews-commerce': isNBCNewsCommerce,
            },
            {
              'related__items--betternews-commerce': isBetterNewsCommerce,
            },
          )}
        >
          {items && items.map((item) => (
            <RelatedItem
              key={item.title}
              item={item}
              linkTracking={linkTracking}
              singleItem={singleItem && isNotRightRail}
              isTrending={isTrending}
              isNBCNewsCommerce={isNBCNewsCommerce}
            />
          ))}
        </div>
      </section>
    );
  }
}

export default Related;
